import type { ReactNode } from 'react'
import type { RelationshipAttribute } from '../RelatedCollection'

export interface RecordSectionContext {
  slug: string
  /** The record's type (Work screen, 2026-10-21: a section that writes to the record names it). */
  typeId?: string
  recordId: string
  attributes: RelationshipAttribute[]
  values: Record<string, unknown>
  period?: { period_start: string; period_end: string }
  onNavigate?: (typeId: string, recordId: string) => void
  /** The type's key figures, in its declared order (display.key_figures, else its calculated highlights). */
  keyFigures?: RelationshipAttribute[]
  /** The record's values are still being read. */
  valuesPending?: boolean
}
export interface RecordSection {
  id: string
  label: string
  count?: number
  /** In the compact peek pane, where the full page's tabs do not fit: 'open'
   *  shows the section under the details; otherwise it sits, collapsed, in
   *  the pane's one "more" disclosure. */
  peek?: 'open' | 'collapsed'
  /** 'top': above the record's details (a record's headline figures). */
  placement?: 'top'
  render: () => ReactNode
}
export interface RecordSectionProvider {
  name: string
  purpose: string
  order: number
  sections: (context: RecordSectionContext) => RecordSection[]
}
const providers = new Map<string, RecordSectionProvider>()
export function registerRecordSections(provider: RecordSectionProvider) { providers.set(provider.name, provider) }
export function registeredRecordSections() { return [...providers.values()].sort((a, b) => a.order - b.order || a.name.localeCompare(b.name)) }
export function recordSectionsFor(context: RecordSectionContext): RecordSection[] {
  return registeredRecordSections().flatMap(provider => provider.sections(context))
}
